<template>
  <v-container class="py-0" fluid>
    <v-row v-if="!result.uid && !orders.length">
      <v-col>
        <span class="my-3">Please verify the params and try again.</span>
      </v-col>
    </v-row>

    <v-row v-if="result.uid" class="subheader__bordered">
      <v-col cols="12" md="2" class="text-center text-left-md">
        <a href="" class="font-weight-bold black--text mr-10-md">
          {{ _.get(order, 'system') }}
        </a>
      </v-col>
      <v-col
        cols="12"
        md="10"
        class="py-0 d-flex justify-center justify-md-start"
      >
        <v-btn
          height="50"
          color="grey darken-4"
          :to="{ name: 'client.business-scope.details', query: $route.query }"
          v-translate="'general.sections.details'"
          tile
          x-small
          text
          depressed
        >Details</v-btn>
        <v-btn
          height="50"
          color="grey darken-4"
          :to="{ name: 'client.business-scope.events', query: $route.query }"
          tile
          x-small
          text
          depressed
        >
          <v-badge dot color="red" :value="events.length">
            {{ 'general.sections.events' | translate }}
          </v-badge>
        </v-btn>
        <v-btn
          height="50"
          color="grey darken-4"
          :to="{ name: 'client.business-scope.contents', query: $route.query }"
          tile
          x-small
          text
          depressed
        >
          <v-badge dot color="red" :value="contents.length">
            {{ 'general.sections.contents' | translate }}
          </v-badge>
        </v-btn>
        <v-btn
          height="50"
          color="grey darken-4"
          :to="{ name: 'client.business-scope.documents', query: $route.query }"
          tile
          x-small
          text
          depressed
        >
          <v-badge dot color="red" :value="documents.length">
            {{ 'general.sections.documents' | translate }}
          </v-badge>
        </v-btn>
        <v-btn
          height="50"
          color="grey darken-4"
          :to="{ name: 'client.business-scope.iot', query: $route.query }"
          v-translate="'general.sections.iot'"
          v-if="isScope('IBM') && hits.length && iotRoute"
          x-small
          text
          depressed
        >
          IOT Tracking
        </v-btn>
      </v-col>
    </v-row>

    <router-view v-if="result.uid || orders.length"></router-view>
  </v-container>
</template>

<script>
import store from '@/store';
// import router from '@/router';
import { mapState } from 'vuex';
import { oftype, Parser } from '@/utils';
import { fetchOrderBeforeEnter } from '@/helpers';
import {
  Scope,
  Mpo,
  Zenith,
} from '@/api';
import {
  get,
  set,
  unset,
  cloneDeep,
  isEmpty,
  isArray,
  // uniqBy,
} from 'lodash';

function fetchScopeByName(to) {
  return Scope.fetch({ name: to.params.scope });
}

/**
 * @param {Route} to
 * @param {Object} scope
 */
async function searchBeforeEnter(to, _, __, scope) {
  const query = cloneDeep(to.query);
  set(query, query.field, query.number);
  unset(query, 'field');
  unset(query, 'number');

  if (query.org) {
    query.org = query.org.toUpperCase();
  }

  if (!isEmpty(to.query)) {
    store.commit('START_LOADING');
    const { data } = await ({ Mpo, Zenith }[scope.system]).search(query);

    // if (isArray(shipment) && scope.system === 'Zenith' && !multiple) [shipment] = data;
    const formated = Parser.map(data, scope.system);
    // if (isArray(formated) && !multiple) return uniqBy(formated, 'shipment');

    return formated;
  }

  return {};
}

export default {
  name: 'app-business-scope-client',
  async beforeRouteEnter(...args) {
    const currentScope = get(await fetchScopeByName(...args), 'data', { });
    const { field, iot } = args[0].query;
    const argsSelf = cloneDeep(args);
    store.commit('CLEAR_ORDER');
    store.commit('SET_SCOPE', currentScope);
    let f = [];

    if (iot === 'true') {
      store.commit('IOT_ACCESS', true);
    }

    // if (
    //   !args[0].matched.some(r => r.meta.search)
    // ) {
    try {
      f = await searchBeforeEnter(
        ...argsSelf,
        currentScope,
        args[0].matched.some(r => r.meta.search),
      );

      // if (
      //   (!f && args[0].name !== 'client.business-scope.details')
      //   || (f && !isArray(f) && args[0].name === 'client.business-scope.search')
      // ) {
      //   router.push({
      //     name: 'client.business-scope.details',
      //     params: args[0].params,
      //     query: args[0].query,
      //   });

      //   return false;
      // }

      // [Deprecated]
      // The next lines are no longer needed, this because a discussion with
      // Kiley about this feature not working or well or don't being needed,
      // for reference you can check more details in the next incident INC0284928.

      // Look for related CSO numbers.
      // if (currentScope.name === 'IBM' && !isArray(f) && args[0].query.field !== 'orderNumber') {
      //   return args[2]({
      //     name: 'client.business-scope.redirect',
      //     params: { scope: currentScope.name },
      //     query: {
      //       field: 'orderNumber',
      //       number: f.orderNumber.split(',')[0],
      //       org: args[0].query.org,
      //     },
      //   });
      // }

      if (f && isArray(f)) {
        args[2]((vm) => {
          /* eslint-disable */
          vm.searching = false;
          vm.searched = true;
          store.commit('SET_SEARCH', f);
          store.commit('END_LOADING');
          vm.currentScope = currentScope;
          /* eslint-enable */
        });
      } else {
        if (f) argsSelf[0].params.number = get(f, 'system');
        else argsSelf[0].params.number = argsSelf[0].query.number;

        fetchOrderBeforeEnter(...argsSelf, currentScope, field)
          .then(() => args[2]((vm) => {
            /* eslint-disable */
            if (args[0].params.number) vm.searched = true;
            store.commit('CLEAR_SEARCH');
            store.commit('END_LOADING');
            vm.searching = false;
            vm.currentScope = currentScope;
            /* eslint-enable */
          }))
          .catch(err => console.debug('FETCH ERR', err))
          .finally(() => {
            store.commit('END_LOADING');
            args[2]((vm) => {
              /* eslint-disable */
              vm.searching = false;
              vm.searched = true;
              vm.currentScope = currentScope;
              /* eslint-enable */
            });
          });
      }
    } catch (err) {
      console.debug(err);
    }

    return true;
    // } else {
    //   store.commit('CLEAR_SEARCH');
    //   store.commit('CLEAR_ORDER');
    //   store.commit('END_LOADING');
    //   args[2]((vm) => {
    //     // eslint-disable-next-line
    //     vm.currentScope = currentScope;
    //   });
    // }
  },
  async beforeRouteUpdate(...args) {
    const { field } = args[0].query;
    const argsSelf = window._
      .chain(args)
      .omit([
        '0.matched',
        '1.matched',
      ])
      .cloneDeep()
      .values()
      .value();
    argsSelf[0].matched = args[0].matched;
    argsSelf[1].matched = args[1].matched;

    if (
      !args[0].matched.some(r => r.meta.search)
       && argsSelf[0].query.number !== argsSelf[1].query.number
    ) {
      const f = await searchBeforeEnter(...argsSelf, this.currentScope);

      if (f && isArray(f)) {
        this.searching = false;
        this.searched = true;
        this.$store.commit('CLEAR_ORDER');
        this.$store.commit('SET_SEARCH', f);
        this.$store.commit('END_LOADING');
        return args[2]();
      }

      if (f) argsSelf[0].params.number = get(f, 'system');
      else argsSelf[0].params.number = argsSelf[0].query.number;

      fetchOrderBeforeEnter(...argsSelf, this.currentScope, field)
        .then(() => {
          store.commit('END_LOADING');
          this.searched = true;
          this.searching = false;
          args[2]();
        })
        .catch(err => console.debug('UPDATE FETCH ERR', err))
        .finally(() => {
          this.$store.commit('END_LOADING');
          this.searched = true;
          this.searching = false;
          args[2]();
        });
    } else {
      this.$store.commit('END_LOADING');
      args[2]();
    }

    return true;
  },
  data() {
    return {
      currentScope: {},
    };
  },
  computed: {
    ...mapState({
      admin: 'IsAdmin',
      result: 'Order',
      results: 'Search',
    }),
    iotRoute() {
      return this.$route.query.iot === 'true';
    },
    order() {
      return this.result;
    },
    orders() {
      const { results } = this;
      if (results) return oftype(results, 'Array') ? results : [results];
      return [];
    },
    events() {
      const { events } = this.result;
      if (events) {
        return (oftype(events, 'Array') ? events : [events])
          .filter(evt => get(evt, 'closeDate'));
      }
      return [];
    },
    documents() {
      const { documents } = this.result;
      if (documents) return oftype(documents, 'Array') ? documents : [documents];
      return [];
    },
    hits() {
      return this.order.hits || [];
    },
    contents() {
      const items = get(this.order, 'items');
      if (items) return oftype(items, 'Array') ? items : [items];
      return [];
    },
  },
  methods: {
    isScope(scope) {
      return scope;
    },
  },
};
</script>
